module.exports = __webpack_public_path__ + "static/media/raisio-logo.178c54a8.svg";